export { default as RecepcionTraslado } from "./RecepcionTraslado";

